import HelpIcon from '@mui/icons-material/Help';
import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import React, { memo } from 'react';

import { StyledTitleBox } from './ResourceRuleEditorTitle.style';

export const ResourceRuleEditorTitle = memo(function ResourceRuleEditorTitle({
    title,
    tooltip,
}: {
    tooltip?: React.ReactNode;
    title: React.ReactNode;
}) {
    return (
        <StyledTitleBox>
            <Box sx={{ marginRight: '20px' }}>{title}</Box>
            {tooltip && (
                <Tooltip title={tooltip} arrow>
                    <HelpIcon cursor="help" />
                </Tooltip>
            )}
        </StyledTitleBox>
    );
});
